import ScrollReveal from './animations/ScrollReveal';
import Header from './components/Header';
import Swiper from 'swiper';
import { Pagination, Navigation } from 'swiper/modules';
import SmoothScroll from './singleton/SmoothScroll';
import WindowSize from './singleton/WindowSize';
import GrimaceScale from './components/GrimaceScale';
import Accordion from './components/Accordion';
import Tooltip from './components/Tooltip';
class Website {
  $body: JQuery<HTMLElement>;
  $links: JQuery<HTMLElement>;
  header: Header;
  smoothScroll: typeof SmoothScroll;
  private windowSize: WindowSize;

  constructor() {
    this.$body = jQuery('body');
    this.$links = jQuery('a');
    this.header = new Header();

    // Activate the smooth scrolling feature.
    this.smoothScroll = SmoothScroll;
    this.windowSize = WindowSize.getInstance();

    this.initObservers();

    this.initScrollingLinks();
    this.initHeroButton();
    this.initSwipers();
    this.initSoundButtons();
    this.initCatCheckScrollResize();
    this.initHackyCrossOrTickStyling();

    new Tooltip();

    jQuery('.accordion').each((_, el) => {
      new Accordion(el);
    });

    jQuery('.grimace-scale').each((_, el) => {
      new GrimaceScale();
    });
  }

  initHackyCrossOrTickStyling() {
    const $cardCopies = jQuery('[class*="group/card-copy"]');
    if (!$cardCopies.length) return;

    $cardCopies.each((_, el) => {
      const $el = jQuery(el);
      // find all X or ✓ symbols in the HTML
      // and wrap them in a span
      const html = $el.html();
      const regex = /(X|✓)/g;
      const replacedHtml = html.replace(regex, (match) => {
        const colorClass = match === 'X' ? 'text-red' : 'text-green';
        return `<span class="text-lg border border-current rounded-full inline-flex size-6 mr-1 items-center leading-none justify-center aspect-square ${colorClass}">${match}</span>`;
      });
      $el.html(replacedHtml);
    });
  }

  initCatCheckScrollResize() {
    const $catCheck = jQuery('.cat-check');
    if (!$catCheck.length) return;

    // set Resize Observer to watch for height changes
    const resizeObserver = new ResizeObserver(() => {
      this.smoothScroll.scroll.resize();
    });

    resizeObserver.observe($catCheck.get(0) as Element);
  }

  initSoundButtons() {
    const $btns = jQuery('.sound-btn');
    if (!$btns.length) return;

    const $audios: JQuery<HTMLAudioElement> = jQuery('audio');

    $audios.on('ended', (e) => {
      const $audio = jQuery(e.currentTarget);
      const $btn = $audio.prev('.sound-btn');
      $btn.removeClass('is-playing');
    });

    $btns.on('click', (e) => {
      const $btn = jQuery(e.currentTarget);
      const $audio = $btn.next('audio');
      if (!$audio.length) return;

      // if is already playing, pause
      if (!$audio[0].paused) {
        $audio[0].pause();
        $btn.removeClass('is-playing');
      } else {
        // Pause all audios
        $audios.each((_, el) => {
          const $cur = jQuery(el);
          const $curBtn = $cur.prev('.sound-btn');
          $curBtn.removeClass('is-playing');
          if (!el.paused) el.pause();
        });

        // if paused, rewind to start
        $audio[0].currentTime = 0;
        $audio[0].volume = 0.5;
        $audio[0].play();
        $btn.addClass('is-playing');
      }
    });
  }

  initSwipers() {
    const $swipers = jQuery('.swiper');
    if (!$swipers.length) return;

    $swipers.each((_, el) => {
      const $el = jQuery(el);
      const loop = $el.data('loop') === true;
      const mobileAutoHeight = $el.data('mobile-auto-height') === true;
      const $pagination = $el.find('.swiper-pagination');
      const $controls = $el.find('.swiper-controls');

      if ($pagination.length || $controls.length) {
        // set pagination position right after the .media
        const $firstSlide = $el.find('.swiper-slide').first();
        const $firstSlideMedia = $firstSlide.find('.media');
        const mediaHeight = $firstSlideMedia.outerHeight() || 0;

        $pagination.css('top', mediaHeight + 8); // 8px = 0.5rem gap
        $controls.css('top', mediaHeight / 2);

        this.windowSize.addListener(() => {
          const mediaHeight = $firstSlideMedia.outerHeight() || 0;
          $pagination.css('top', mediaHeight + 8);
          $controls.css('top', mediaHeight / 2);
        });
      }

      const swiper = new Swiper(el, {
        modules: [Pagination, Navigation],
        spaceBetween: 20,
        speed: 600,
        slideToClickedSlide: true,
        loop,
        breakpoints: {
          1024: {
            spaceBetween: 40,
          },
        },
        pagination: {
          el: $el.find('.swiper-pagination').get(0) || undefined,
          clickable: true,
        },
        navigation: {
          nextEl: $el.find('.swiper-button-next').get(0) || undefined,
          prevEl: $el.find('.swiper-button-prev').get(0) || undefined,
          // scroll to start on prev when on last slide
        },
      });
    });
  }

  initHeroButton() {
    const $btns = jQuery('.hero-btn');
    if (!$btns.length) return;
    $btns.on('click', (e) => {
      const $btn = jQuery(e.currentTarget);
      const $section = $btn.closest('section');
      if (!$section.length) return;
      const $nextSection = $section.next('section');
      if (!$nextSection.length) return;
      this.smoothScroll.scrollToSection($nextSection);
    });
  }


  initScrollingLinks() {
    this.$links.on('click', this.linkClicked.bind(this));
    this.scrollOnPageLoad();
  }

  linkClicked(e: JQuery.ClickEvent) {
    const $cur = jQuery(e.currentTarget);
    const href = $cur.attr('href');
    if (!href) return;
    const hrefArr = href.split('#');
    const { pathname, origin, host } = window.location;

    // If the href is empty or just a hash, or if it's not a hash but the
    // path doesn't match the current page, do nothing.
    if (
      !href ||
      href === '#' ||
      (!href.startsWith('#') && !href.includes('#')) ||
      (!href.startsWith('#') &&
        hrefArr[0] !== pathname &&
        hrefArr[0] !== origin + pathname &&
        hrefArr[0] !== '//' + host + pathname)
    ) {
      return;
    }

    const $target = href.startsWith('#')
      ? jQuery(href)
      : jQuery(`#${hrefArr[1]}`);
    if ($target.length) {
      e.preventDefault();

      if (this.header.headerIsOpened) {
        this.header.closeNav();
      }

      this.smoothScroll.scrollToSection($target);

      // update url hash
      // window.history.pushState(null, '', href);
    }
  }

  scrollOnPageLoad() {
    const { hash } = window.location;

    if (!hash || hash === '#') return;
    const $target = jQuery(hash);
    if (!$target.length) return;

    setTimeout(() => {
      this.smoothScroll.scrollToSection($target);
    }, 200);
  }

  initObservers() {
    new ScrollReveal(
      jQuery(
        '[data-visibility]:not([data-is-visible]), [data-visibility-inside]>*:not([data-is-visible])',
      ),
    );
  }
}

jQuery(function () {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const website = new Website();
});
